import { toast } from 'react-toastify';

import { Toast } from '@/components/generic/Toast/Toast';
import { TOAST_CLASS, UPLOAD_ERROR_TRANSLATION_KEYS } from '@/constants';
import i18n from '@/i18n';
import { AssetUploadErrorType, UploadErrorDetail, UploadSummary } from '@/types';
import { TFunction } from 'i18next';

// TODO: Move toast enums/constants to the appropriate files during refactoring.
export enum ToastType {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning'
}

export const ToastTypes = {
  [ToastType.SUCCESS]: toast.success,
  [ToastType.ERROR]: toast.error,
  [ToastType.INFO]: toast.info,
  [ToastType.WARNING]: toast.warning
};

export type ToastPayload = {
  text: string;
  details?: UploadErrorDetail[];
  isCollapsible?: boolean;
  autoClose?: boolean;
};
export const showToast = (type: ToastType, payload: string | ToastPayload) => {
  if (!payload) {
    return;
  }

  const normalizedPayload =
    typeof payload === 'string'
      ? { text: payload }
      : payload;

  if (!normalizedPayload.text) {
    return;
  }

  const toastNotification = (
    <Toast
      text={normalizedPayload.text}
      details={normalizedPayload.details}
      isCollapsible={normalizedPayload.isCollapsible}
    />
  );

  ToastTypes[type](toastNotification, {
    className: TOAST_CLASS,
    autoClose: normalizedPayload.autoClose === false ? false : undefined
  });
};

export const showUploadErrorToast = (errorType: AssetUploadErrorType) => {
  const translationKey = UPLOAD_ERROR_TRANSLATION_KEYS[errorType] ?? 'assetError';
  showToast(ToastType.ERROR, i18n.t(translationKey, { ns: 'common' }));
};

export const showUploadSummaryToast = (summary: UploadSummary, t: TFunction) => {
  const { uploadedCount, failedCount, errors } = summary;

  if (failedCount === 0) {
    showToast(ToastType.SUCCESS, {
      text: t(uploadedCount === 1 ? 'assetsSuccessfullyUploadedSummary' : 'assetsSuccessfullyUploadedSummaryPlural', {uploadedCount})
    });
    return;
  }

  if (uploadedCount === 0) {
    if (failedCount === 1 && errors.length === 1) {
      showUploadErrorToast(errors[0].errorType);
      return;
    }
    showToast(ToastType.ERROR, {
      text: t('assetsUploadFailed', {failedCount}),
      details: errors,
      isCollapsible: true,
      autoClose: false
    });
    return;
  }

  showToast(ToastType.WARNING, {
    text: t(uploadedCount === 1 ? 'assetsUploadWarningSummary' : 'assetsUploadWarningSummaryPlural', {
      uploadedCount,
      failedCount
    }),
    details: errors,
    isCollapsible: true,
    autoClose: false
  });
};
